import { render } from "./NewListmorenew.vue?vue&type=template&id=94d98cb8&scoped=true"
import script from "./NewListmorenew.vue?vue&type=script&lang=js"
export * from "./NewListmorenew.vue?vue&type=script&lang=js"

import "./NewListmorenew.vue?vue&type=style&index=0&id=94d98cb8&lang=css"
import "./NewListmorenew.vue?vue&type=style&index=1&id=94d98cb8&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d98cb8"]])

export default __exports__